import { type PeriodInterval } from 'src/core/modules/budgets/models/periodInterval';

import {
  toPeriodRangePayload,
  type PeriodRange,
} from '../../../../models/periodRange';

export const makePeriod = (
  budgetPeriod: PeriodInterval,
  periodRange: PeriodRange,
): PeriodInterval => {
  const periodRangePayload = toPeriodRangePayload(periodRange);
  return {
    start: periodRangePayload.from ?? budgetPeriod.start,
    end: periodRangePayload.to ?? budgetPeriod.end,
  };
};
